/**
 * THEME JSON CONFIG CSS VARS
 * The following default component scss variables can be overwritten via theme configuration per brand.
 * If you need to add new one, please make sure to set a default value.
 * JSON Definition for Component with name "Example": testCssVar: "20px"
 * Resulting CSS var: $example-test-css-var: 20px;
 */
$rte-renderer-list-item-gap: 16px !default;
$rte-renderer-list-item-padding-start: 4px !default;
$rte-renderer-list-padding-start: 32px !default;
$rte-renderer-list-marker-font-weight: bold !default;
$rte-renderer-list-style-position: outside !default;
$rte-renderer-ul-style-type: disc !default;
$rte-renderer-ol-style-type: decimal !default;

/* END THEME JSON CONFIG CSS VARS ******************************************************* */

@mixin list-styles {
  ul,
  ol {
    padding-inline-start: $rte-renderer-list-padding-start;
    list-style-position: $rte-renderer-list-style-position;

    li {
      @include eon-typography("copy");

      margin-bottom: $rte-renderer-list-item-gap;
      padding-inline-start: $rte-renderer-list-item-padding-start;

      &:last-child {
        margin-bottom: 0;
      }

      &::marker {
        @include eon-typography("copy");
        font-weight: $rte-renderer-list-marker-font-weight !important;
      }
    }
  }

  ul {
    list-style-type: $rte-renderer-ul-style-type;
  }

  ol {
    list-style-type: $rte-renderer-ol-style-type;
  }
}

* {
  margin: 0;
  padding: 0;
}

*,
*::after,
*::before {
  box-sizing: border-box;
  outline: 0 none;
  text-rendering: optimizelegibility;
}

:host {
  display: block;
}

:host(.#{$prefix}info-icon-display) {
  display: flex;
}

.#{$prefix}rte-renderer-info-icon {
  align-items: flex-start;
  margin: 0 16px;
}

.#{$prefix}renderer-content {
  &.#{$prefix}rte-source-aem {
    counter-reset: list-0;
    color: v(paragraphColor);
    @include eon-typography("copy");
    line-height: var(--rteRendererLineHeight, var(--lineHeight)) !important;

    p,
    /* h4,
    h5, */
    h6 {
      counter-reset: list-0;
    }

    p {
      @include eon-typography("copy");
      line-height: var(--rteRendererLineHeight, var(--lineHeight)) !important;
      margin-bottom: 8px;

      eon-ui-link {
        @include eon-typography("copy");
      }
    }

    span {
      display: inline-block;

      &.eon-copy-small {
        @include eon-typography("copy-small");
        line-height: var(--rteRendererLineHeight, var(--lineHeight)) !important;

        eon-ui-link {
          @include eon-typography("copy-small");
        }
      }

      &.eon-abstract {
        @include eon-typography("abstract");
        margin-bottom: 16px;

        @include for-size(phone) {
          margin-bottom: 8px;
        }
      }
    }

    a.sc-eon-ui-rte-renderer {
      background-color: transparent !important;
    }

    p.sc-eon-ui-rte-renderer {
      &:only-child {
        margin-bottom: 0;
        span {
          &.eon-abstract {
            margin-bottom: 0;
          }
        }
      }

      &:last-child {
        margin-bottom: 0;
        span {
          &.eon-abstract {
            margin-bottom: 0;
          }
        }
      }
    }

    h6 {
      @include eon-typography("h6");
      color: v(sublineColor);
      margin-bottom: 16px;
    }

    * {
      + h6 {
        margin-top: 32px;

        @include for-size(tablet-or-smaller) {
          margin-top: 24px;
        }
      }
    }

    @include list-styles();

    ul.sc-eon-ui-rte-renderer,
    ol.sc-eon-ui-rte-renderer {
      &:only-child {
        margin-bottom: 0;
      }

      &:last-child {
        margin-bottom: 0;
      }
    }

    blockquote {
      position: relative;
      margin-top: 32px;
      margin-bottom: 32px;
      padding-left: 24px;
      display: block;

      &::before {
        content: "";
        position: absolute;
        left: 0;
        top: -16px;
        width: 8px;
        height: calc(100% + 32px);
        padding: 16px 0px 16px 0px;
        background-color: v(blockquoteColor);
        display: block;
        opacity: 0.5;
      }

      + blockquote {
        margin-top: -24px;

        &::before {
          top: 8px;
          height: calc(100% + 8px);
          padding-bottom: 0px;
        }
      }
    }

    blockquote.sc-eon-ui-rte-renderer {
      &:only-child {
        margin-bottom: 0;
      }

      &:last-child {
        margin-bottom: 0;
      }
    }

    sup {
      vertical-align: super;
      line-height: 0;
      top: -1px;
      font-size: 12px !important;
    }

    sub {
      vertical-align: sub;
      line-height: 0;
      bottom: 0px;
      font-size: 12px !important;
    }

    b {
      font-weight: bolder !important;
    }

    a {
      cursor: pointer;
      font-weight: bold;
      color: v(linkColor);

      &:focus-visible {
        @include focusBorder(v(linkOutlineColor), 2px);
        border-radius: 4px;
        // text-decoration: none => had to remove because of Safari bug.
      }

      &:hover {
        color: v(linkHoverColor);
        opacity: v(linkHoverOpacity);
        text-decoration: underline;
      }
    }
  }

  &.#{$prefix}rte-source-quill {
    counter-reset: list-0;

    p {
      margin: 0;
      padding: 0;
    }

    p,
    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
      counter-reset: list-0 list-1 list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9;
    }

    .ql-align-center {
      text-align: center;
    }

    .ql-align-justify {
      text-align: justify;
    }

    .ql-align-right {
      text-align: right;
    }

    /* is this relevant? someone spent time for custom list item markers...
    li {
      list-style-type: none;
      padding-left: 1.5em;
      position: relative;

      > .ql-ui:before {
        display: inline-block;
        margin-left: -1.5em;
        margin-right: 0.3em;
        text-align: right;
        white-space: nowrap;
        width: 1.2em;
      }

      &[data-list="checked"] > .ql-ui,
      &[data-list="unchecked"] > .ql-ui {
        color: #777;
      }

      &[data-list="bullet"] > .ql-ui:before {
        content: "\2022";
      }

      &[data-list="checked"] > .ql-ui:before {
        content: "\2611";
      }

      &[data-list="unchecked"] > .ql-ui:before {
        content: "\2610";
      }

      &[data-list="ordered"] {
        counter-reset: list-1 list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9;
        counter-increment: list-0;

        > .ql-ui:before {
          content: counter(list-0, decimal) ". ";
        }
      }
    }
    */

    /*
     *
     * E.ON CUSTOM STYLES
     *
     */

    color: v(paragraphColor);
    @include eon-typography("copy");
    line-height: var(--rteRendererLineHeight, var(--lineHeight)) !important;

    p {
      @include eon-typography("copy");
      line-height: var(--rteRendererLineHeight, var(--lineHeight)) !important;
      margin-bottom: 8px;
      display: block;

      eon-ui-link {
        @include eon-typography("copy");
      }
    }

    .ql-font-copy {
      @include eon-typography("copy");
      line-height: var(--rteRendererLineHeight, var(--lineHeight)) !important;
      margin-bottom: 8px;
      display: block;

      eon-ui-link {
        @include eon-typography("copy");
      }
    }

    .ql-font-copy-small {
      @include eon-typography("copy-small");
      line-height: var(--rteRendererLineHeight, var(--lineHeight)) !important;
      /* margin-bottom: 8px; */
      display: inline-block;

      eon-ui-link {
        @include eon-typography("copy-small");
      }
    }

    .ql-font-abstract {
      @include eon-typography("abstract");
      margin-bottom: 16px;
      display: inline-block;

      @include for-size(phone) {
        margin-bottom: 8px;
      }
    }

    .ql-font-subheadline {
      @include eon-typography("h6");
      color: v(sublineColor);
      margin-bottom: 8px;
      display: inline-block;
    }

    * {
      + p {
        .ql-font-subheadline {
          margin-top: 24px;

          @include for-size(tablet-or-smaller) {
            margin-top: 16px;
          }
        }

        + blockquote {
          margin-top: 24px;
        }
      }
    }

    @include list-styles();

    blockquote {
      position: relative;
      margin-top: 32px;
      margin-bottom: 32px;
      padding-left: 24px;
      display: block;

      &::before {
        content: "";
        position: absolute;
        left: 0;
        top: -16px;
        width: 8px;
        height: calc(100% + 32px);
        padding: 16px 0px 16px 0px;
        background-color: v(blockquoteColor);
        display: block;
        opacity: 0.5;
      }

      + blockquote {
        margin-top: -24px;

        &::before {
          top: 8px;
          height: calc(100% + 8px);
          padding-bottom: 0px;
        }
      }
    }

    sup {
      vertical-align: super;
      line-height: 0;
      top: -1px;
      font-size: 12px !important;
    }

    sub {
      vertical-align: sub;
      line-height: 0;
      bottom: 0px;
      font-size: 12px !important;
    }

    strong {
      font-weight: bolder !important;
    }

    a {
      cursor: pointer;
      font-weight: bold;
      color: v(linkColor);

      &:focus-visible {
        @include focusBorder(v(linkOutlineColor), 2px);
        border-radius: 4px;
        // text-decoration: none => had to remove because of Safari bug.
      }

      &:hover {
        color: v(linkHoverColor);
        opacity: v(linkHoverOpacity);
        text-decoration: underline;
      }
    }

    .quill-better-table {
      border-collapse: collapse;
      td {
        border: 1px solid #000;
      }
      td[data-cell-highlight="true"] {
        border-color: green;
        border-width: 2px;
      }
    }
  }
}
